import { defineMessages } from "react-intl";

export const swatchFieldMessages = defineMessages({
  image: {
    id: "I2wCwj",
    defaultMessage: "Image",
    description: "swatch attribute image label",
  },
  picker: {
    id: "0DgA8v",
    defaultMessage: "Picker",
    description: "swatch attribute color picker label",
  },
});
